import React, { useEffect, useState } from 'react';
import {
  Pagination,
  Button,
  Search,
  Select,
  Table,
  IconDownload,
} from '@veneer/core';
import recommendedPricePreferences from './RecommendedPriceList.preferences';
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { currencyFormat, numberFormatComma } from './../../../common/js/utils/numberFormat';
import XLSX from 'xlsx';
import { Trans } from 'react-i18next';

const RecommendedPriceList = (props) => {

  const [idPartValue, setidPartValue] = useState('');
  const [descriptionValue, setDescriptionValue] = useState('');

  const configGeneral = [
    {
      id: 'idPart',
      label: 'PN',
      filter: (
        <Search
          name="idPart-search"
          value={idPartValue}
          onChange={setidPartValue}
        />
      ),
    },
    {
      id: 'description',
      label: <Trans i18nKey='Description' />,
      filter: (
        <Search
          name="descriptionMex-search"
          value={descriptionValue}
          onChange={setDescriptionValue}
        />
      ),
    },
    {
      id: 'msrpFormatted',
      label: 'MSRP (USD)'
    },
    {
      id: 'units',
      label: <Trans i18nKey='pricelist.table.units' />
    },
  ];

  const connectApi = new ConnectAPI();
  const [regionSelected, setRegionSelected] = useState('BR');
  const [config, setConfig] = useState(configGeneral);
  const [order, setOrder] = useState(config.map((c) => c.id));
  const [orderBy, setOrderBy] = useState('idPart');
  const [orderType, setOrderType] = useState('descending');
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredColumns, setfilteredColumns] = useState([]);
  const [data, setData] = useState([]);
  const [recommendedPriceRegion, setrecommendedPriceRegion] = useState([]);
  const [dataResponse, setDataResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const pageSize = 50;

  const exportData = () => {
    setLoadingExport(true);
    setTimeout(() => {
      let excelData = recommendedPriceRegion;
      filteredColumns.forEach((filter) => {
        excelData = excelData.filter((row) =>
          row[filter.column]
            .toString()
            .toLowerCase()
            .includes(filter.filterValue.toLowerCase())
        );
      });
      //const data = this.state.endUsers;
      //console.log(excelData);
      let headerEndUsers = ['description', 'idPart', 'msrp'];
      //let dataBody = [];
      const dataXlsx = excelData.map((item) => {
        return {
          description: item.description,
          idPart: item.idPart,
          msrp: item.msrp,
        };
      });

      const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: headerEndUsers });
      const wb = XLSX.utils.book_new();

      const date = moment(new Date()).format('YYYYMMDDHHmm');

      const filename = 'RecommendedPriceList -' + date + '.xlsx';
      const ws_name = 'Balance';

      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(wb, filename);

      setLoadingExport(false);
    }, 750);
  };

  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
    const fetchData = async () => {
      setIsLoading(true);

      connectApi
        .get('api/Channels/recommendedPrice', '', dataResponseLoad)
        .catch((error) => {
          setIsLoading(false);
          Swal.fire(
            'Error ' + error.response.status,
            error.response.data,
            'error'
          );
        });
    };

    const dataResponseLoad = (status, data) => {
      //console.log(data);
      data.map((item) => {
        item.msrpFormatted =
          item.msrp == null ? '-' : currencyFormat(item.msrp, 'USD');
      });

      setDataResponse(data === undefined ? [] : data);
      setTableData(data === undefined ? [] : data);

      setrecommendedPriceRegion(data.filter((item) => item.idCountry === 'BR'));
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const handlePageChange = (page) => setCurrentPage(page);

  const handleOnColumnReorder = (newOrder) => {
    setOrder(newOrder);
  };

  const filteredData = filterSort(
    tableData,
    {
      idPart: idPartValue,
      description: descriptionValue,
      idCountry: regionSelected
    },
    orderBy,
    orderType
  );

  useEffect(() => {
    pagedData = filteredData.slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
  }, [regionSelected]);

  function filterSort(array, filters, orderBy, orderType) {
    let arrayFiltered = array;
    // filter
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      const filter = typeof filterValue === 'object' ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();

          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });

    // sort
    return arrayFiltered.sort((a, b) => {
      const value =
        orderType === 'descending'
          ? descendingComparator(a, b, orderBy)
          : -descendingComparator(a, b, orderBy);

      return value;
    });
  }

  function descendingComparator(a, b, orderBy) {
    let aSort =
      typeof a[orderBy] === 'object'
        ? typeof a[orderBy] === typeof (<a />)
          ? a[orderBy].props.href.toString().toUpperCase()
          : a[orderBy].props.label.toString().toUpperCase()
        : a[orderBy].toString().toUpperCase();
    //const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
    let bSort =
      typeof b[orderBy] === 'object'
        ? typeof b[orderBy] === typeof (<a />)
          ? b[orderBy].props.href.toString().toUpperCase()
          : b[orderBy].props.label.toString().toUpperCase()
        : b[orderBy].toString().toUpperCase();
    //const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();

    if (orderBy === 'dateFormatted') {
      aSort = a['date'];
      bSort = b['date'];
    } else {
      if (orderBy.includes('Formatted')) {
        const orderByFormatted = orderBy.replace('Formatted', '');
        aSort = a[orderByFormatted];
        bSort = b[orderByFormatted];
      }
    }
    if (bSort < aSort) {
      return -1;
    }
    if (bSort > aSort) {
      return 1;
    }
    return 0;
  }

  let pagedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );

  useEffect(() => {
    // console.log(customerName);
    pagedData = filteredData.slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
    //}, [customerName, endUserName, serviceArea]);
  }, []);
  

  const handleSort = (_, { id, type }) => {
    setOrderBy(id);
    setOrderType(type);
  };

  const renderRegionOptions = () => {
    const handleRegionChange = (name) => (event) => {
      setRegionSelected(event.value);
    };

    return (
      <div
        style={{
          width: '230px',
          padding: '0.5% 2% ',
        }}
      >
        <Select
          name="type"
          onChange={handleRegionChange()}
          options={[
            {
              value: 'BR',
              label: <Trans i18nKey="Brazil" />,
            },
            {
              value: 'MX',
              label: <Trans i18nKey="Mexico" />,
            },
            {
              value: 'CO',
              label: <Trans i18nKey="Colombia" />,
            },
          ]}
          value={[regionSelected]}
          clearIcon={false}
        ></Select>
      </div>
    );
  };

  return (
    <div>
      <br />

      <div>
        <br />
        <div className="row" style={{ textAlign: 'left', padding: '0.5%' }}>

          {renderRegionOptions()}
        </div>
        <div
          style={{
            backgroundColor: '#f2f2f2',
            padding: '0.5%',
            // maxWidth: '760px',
          }}
        >
          <Table
            showFilters
            columnReorder
            columns={config}
            data={pagedData}
            onColumnReorder={handleOnColumnReorder}
            onSort={handleSort}
            loading={isLoading}
            preferences={{
              defaultOrder: config.map((c) => c.id),
              order,
              sortBy: {
                id: orderBy,
                type: orderType,
              },
            }}
            pagination={{
              currentPage,
              onPageChange: handlePageChange,
              pageSize,
              totalItems: filteredData.length,
            }}
          ></Table>
          <div style={{ textAlign: 'left' }}>
            <Button
              leadingIcon={<IconDownload />}
              onClick={() => {
                exportData();
              }}
              disabled={tableData === 0}
              loading={loadingExport}
              title="Download Data"
            >
              <Trans i18nKey="download" />
            </Button>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default RecommendedPriceList;
